import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { PictureElement } from "./PictureElement";
import React from "react";
import { Text } from "./Text";
import { PLPCardSubheadline } from "./PLPCardSubheadline";
import { PLPHeadlineWithNew } from "./PLPHeadlineWithNew";

export const PLPContent: ReactTFC<{
  asset?: string;
  headline: string;
  isNew: boolean;
  subheadlines: Array<{ name: string; isNew: boolean }>;
  text?: string;
}> = ({ headline, isNew, subheadlines, asset, text }) => {
  return (
    <>
      <PictureElement asset={asset} key={asset} />
      <PLPHeadlineWithNew headline={headline} isNew={isNew} />
      <PLPCardSubheadline subheadlines={subheadlines} />
      {text && <Text>{text}</Text>}
    </>
  );
};
